import { useMutation } from "react-query";
import updateRegtankOnboardingReattemptApproval from "../services/updateRegtankReattemptApproval";

function useUpdateRegtankOnboardingReattemptApproval() {
  return useMutation(
    ["updateRegtankOnboardingReattempt"],
    updateRegtankOnboardingReattemptApproval
  );
}

export default useUpdateRegtankOnboardingReattemptApproval;
